import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import type { ButtonProps } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export type CrudAction = 'create' | 'update' | 'delete';

export type CrudActionButtonProps = Omit<ButtonProps, 'action'> & {
  action: CrudAction;
};

const ACTION_DEFAULTS: Record<CrudAction, { color: NonNullable<ButtonProps['color']>; endIcon: ReactNode }> = {
  create: { color: 'success', endIcon: <AddIcon /> },
  update: { color: 'secondary', endIcon: <EditIcon /> },
  delete: { color: 'error', endIcon: <DeleteIcon /> },
};

const CrudActionButton = forwardRef<HTMLButtonElement, CrudActionButtonProps>(function CrudActionButton(
  { action, color, endIcon, fullWidth = true, size = 'medium', variant = 'contained', sx, ...buttonProps },
  ref
) {
  const defaults = ACTION_DEFAULTS[action];

  return (
    <Button
      ref={ref}
      color={color ?? defaults.color}
      endIcon={endIcon ?? defaults.endIcon}
      fullWidth={fullWidth}
      size={size}
      variant={variant}
      sx={[
        ...(action === 'create'
          ? [
              {
                color: 'white',
                border: 'none',
                '&:hover': {
                  backgroundColor: 'rgb(83, 189, 83, 0.8)',
                  border: 'none',
                  boxShadow: 'none',
                },
              },
            ]
          : []),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...buttonProps}
    />
  );
});

export default CrudActionButton;
